import { MaskLines, Reveal } from "./Motion";

const NOTES = [
  "Artist, manager and label feedback is being collected during the beta.",
  "Results are published here only after they are verified.",
  "No invented numbers. Just the work, tracked honestly.",
];

export const Proof = () => (
  <section data-testid="proof-section" className="border-t border-white/10">
    <div className="mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12">
      <MaskLines
        as="p"
        label="Built for independent artists, managers and music teams."
        lines={["“Built for independent", "artists, managers", "and music teams.”"]}
        className="font-display text-[clamp(2.4rem,5.5vw,5rem)] uppercase leading-[0.92] text-pa-ink"
      />
      <div className="mt-14 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
        {NOTES.map((n, i) => (
          <Reveal key={n} delay={i * 0.08} className="bg-pa-bg p-7">
            <span className="font-mono text-xs text-pa-orange-text">0{i + 1} · Proof comes next</span>
            <p className="mt-4 text-[15px] leading-relaxed text-pa-muted">{n}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
